import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { putErrorNotification } from '../../../../../../../utils/saga';
import { initialize, initializeSuccess, initializeError } from '../actions';
import type {
  PapiRequestDaDeviationInit,
  PapiRequestDaSharedDeviationSubmitInit,
} from '@wix/da-papi-types';
import { getDeviationPageTypeFromTypeId } from '../../../../../../../Duperbrowse/redux/loader';
import { DeviationResourceType } from '../../../../../../../types/deviation';

function* initializeSaga(action: ReturnType<typeof initialize>): SagaIterator {
  const {
    payload: { deviationId, username, typeId },
  } = action;

  const isTierDeviation = typeId === DeviationResourceType.TIER;

  let response;

  if (isTierDeviation) {
    // For tier deviations, use dadeviation/init as submit/init doesn't support tiers
    const params: PapiRequestDaDeviationInit = {
      deviationid: deviationId,
      username,
      type: getDeviationPageTypeFromTypeId(typeId),
      include_session: false,
    };

    response = yield call(
      requestPuppy,
      {
        method: 'get',
        url: '/init',
        params,
      },
      undefined,
      'dadeviation'
    );
  } else {
    // For non-tier deviations, use submit/init as it comes with recommended tags
    const params: PapiRequestDaSharedDeviationSubmitInit = {
      deviationid: deviationId.toString(),
      with_session: false,
    };

    response = yield call(
      requestPuppy,
      {
        method: 'get',
        url: '/deviation/submit/init',
        params,
      },
      undefined,
      'dashared'
    );
  }

  if (!response || !response.deviation || isApiError(response)) {
    const errorMessage = 'Failed to initialize boost';
    yield putErrorNotification(errorMessage);
    yield put(initializeError(errorMessage));

    return;
  }

  // Store the deviation directly in the boost modal store slice
  const payload = {
    deviation: response.deviation,
    tags:
      (response.tags || response.deviation.extended.tags)?.map(
        tag => tag.name
      ) || [],
    recommendedTags: response.recommendedTags?.map(tag => tag.name) || [],
  };

  yield put(initializeSuccess(payload));
}

export default function* boostSaga() {
  yield takeEvery(initialize, initializeSaga);
}
